export default "__VITE_ASSET__DPyzPH5x__"